<template>
  <!-- eslint-disable -->
  <b-sidebar
    id="add-new-speciality"
    :visible="isAdd"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    no-close-on-backdrop
    @change="(val) => $emit('update:is-add', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">{{ isEdit ? 'Editar' : 'Agregar nueva' }} importacion</h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="[hide(), resetForm()]" />
      </div>

      <!-- BODY -->
      <validation-observer #default="{ invalid }" ref="refFormObserver">
        <!-- Form -->
          <b-form class="p-2" @submit.prevent="onSubmit">
          <!-- Campos para Importación -->
          <div>
            <validation-provider #default="{ errors }" name="enterprise" rules="requeridoE">
            <b-form-group label="Nombre Empresa">
              <b-form-input v-model="items.enterprise" placeholder="Nombre de la empresa" />
              <span class="text-danger">{{ errors[0] }}</span>
            </b-form-group>
            </validation-provider>

            <validation-provider #default="{ errors }" name="ruc" rules="requeridoE">
            <b-form-group label="RUC Empresa">
              <b-form-input v-model="items.ruc" placeholder="RUC de la empresa" />
              <span class="text-danger">{{ errors[0] }}</span>
            </b-form-group>
            </validation-provider>

            <validation-provider #default="{ errors }" name="dua" rules="requeridoE">
            <b-form-group label="DUA (código)">
              <b-form-input v-model="items.dua" placeholder="Código DUA" />
              <span class="text-danger">{{ errors[0] }}</span>
            </b-form-group>
            </validation-provider>

            <validation-provider #default="{ errors }" name="establishmentId" rules="requeridoE">
            <b-form-group label="Almacén">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                v-model="items.establishmentId"
                :options="locals"
                :reduce="local => local.id"
                label="name"
                placeholder="Seleccionar Almacén"
              />
              <span class="text-danger">{{ errors[0] }}</span>
            </b-form-group>
            </validation-provider>
          </div>

          <!-- Form Actions -->
          <div class="d-flex mt-2 justify-content-end">
            <b-button
              :disabled="invalid"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              <b-spinner v-if="isDisabled" small />
              <span v-if="isDisabled" class="px-1">guardando...</span>
              <span v-else>{{ isEdit ? 'Actualizar' : 'Agregar' }}</span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="[hide(), resetForm()]"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
/* eslint-disable*/
import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import StoresService from '@/services/StoresService'
import ImportService from '@/services/ImportService'
import vSelect from 'vue-select'
Vue.use(BootstrapVue)
export default {
  directives: {
    Ripple
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect
  },
  props: {
    isAdd: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      required,
      isEdit: false,
      isDisabled: false,
      items: {
        enterprise: '',
        dua: '',
        ruc: '',
        establishmentId: null
      },
      temp: {},
      locals: []
    }
  },
  mounted(){
    this.filterLocal()
  },
  methods: {
    async filterLocal() {
      const arrayFilters = [{ keyContains: 'establishmentType', key: 'equals', value: 'WAREHOUSE' }]
      const url = `?limit=10&page=1&order=desc&sort=id&filter=${JSON.stringify(arrayFilters)}`
      
      try {
        const resp = await StoresService.getStores(url, this.$store)
        if (resp && resp.data && resp.data.rows) {
          this.locals = resp.data.rows
        }
      } catch (error) {
        console.error('Error al obtener los locales:', error)
      }
    },
    getData(items) {
      if (Object.entries(items).length !== 0) {
        this.temp = items;
        this.items = { ...items }; 
        this.isEdit = true;
      } else {
        this.resetForm();
      }
      console.log('temp EN ADD', this.temp)
    },
    resetForm() {
      this.$refs.refFormObserver.reset()
      this.temp = {
        enterprise: '',
        dua: '',
        ruc: '',
        establishmentId: null
      }
      this.typeLocal = null
      this.isEdit = false
      this.items = this.temp
    },
    async onSubmit() {
      console.log('data', this.items)
      this.$refs.refFormObserver.validate().then(async (success) => {
        if (success) {
          this.isDisabled = true
          let resp = ''
          const payload = {
            enterprise: this.items.enterprise,
            ruc: this.items.ruc,
            dua: this.items.dua,
            establishmentId: this.items.establishmentId,
          };
          if (this.isEdit == false) {
            resp = await ImportService.saveImport(payload, this.$store)
          } else {
            resp = await ImportService.updateImport(this.items.id, payload, this.$store)
          }
          console.log('resp',resp)
          if (resp) {
            this.$swal({
              title: 'Añadido',
              text: 'La importación ha sido ' + (this.isEdit == true ? 'actualizada.' : 'registrada.'),
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              buttonsStyling: false
            })
            console.log('this.$parent.$parent', this.$parent.$parent)
            this.$parent.$parent.$parent.getData()
            this.$emit('update:is-add', false)
            this.resetForm()
          } else {
            this.$swal({
              title: 'Error!',
              text: ' Hubo un error al ' + (this.isEdit == true ? 'actualizar' : 'registrar') + ' la importación',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary'
              },
              buttonsStyling: false
            })
          }
          this.isDisabled = false
        } else {
          console.log('no validado')
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
